/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Maxlabel1Inputs */

const zh_plan_maxlabel1 = /** @type {(inputs: Plan_Maxlabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max`)
};

const en_plan_maxlabel1 = /** @type {(inputs: Plan_Maxlabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max`)
};

const es_plan_maxlabel1 = /** @type {(inputs: Plan_Maxlabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max`)
};

/**
* | output |
* | --- |
* | "Max" |
*
* @param {Plan_Maxlabel1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const plan_maxlabel1 = /** @type {((inputs?: Plan_Maxlabel1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Maxlabel1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_plan_maxlabel1(inputs)
	if (locale === "en") return en_plan_maxlabel1(inputs)
	return es_plan_maxlabel1(inputs)
});
export { plan_maxlabel1 as "plan_maxLabel" }